<app-simple-modal [title]="'Días sin '+ (isXMLE ? 'XMLE' : 'XMLR')" [max]="80" [requiredFields]="false"
	(close)="close.emit($event)">
	<div fields>
		<h1 style="text-align: center;">{{companyName}}</h1>
		<div class="table-responsive">
			<table class="table table-stripped">
				<thead>
					<tr class="tr-middle">
						<th>Bodega</th>
						<th>Días sin {{isXMLE ? 'XMLE' : 'XMLR'}}</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let day of xml" class="tr-middle">
						<td>
							{{day.warehouseName}}
						</td>
						<td>
							{{day.quantity}}
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</app-simple-modal>